import PartsForm from './Form';

export default PartsForm;
